import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { DeviceOsUpdateStatusComponent } from './device-os-update-status.component';
import { AsyncPipe } from '@angular/common';
import {
  DevicesOsUpdateStatusSelectors,
  DevicesOsUpdateStatusStates,
} from '../../sub-features/device-os-updates/devices-os-update-statuses-store';

@Component({
  selector: 'era-device-os-update-status',
  templateUrl: './device-os-update-status.container.html',
  styleUrls: ['./device-os-update-status.container.scss'],
  imports: [DeviceOsUpdateStatusComponent, AsyncPipe],
})
export class DeviceOsUpdateStatusContainerComponent {
  readonly osUpdateStatus$: Observable<DevicesOsUpdateStatusStates.OSUpdateStatus>;

  constructor(private readonly store: Store<DevicesOsUpdateStatusStates.OSUpdateStatus>) {
    this.osUpdateStatus$ = this.store.select(DevicesOsUpdateStatusSelectors.selectOsUpdateStatusByUdid);
  }
}
